import { createContext, useContext } from 'react';

import { PaymentProps } from '../../types';

export interface PaymentContextProps extends PaymentProps {
  callPaymentAnalytics: () => Promise<void>;
  isCardRequired: boolean;
  voucher?: string;
}

export const PaymentContext = createContext({} as PaymentContextProps);

export const usePaymentContext = () => useContext(PaymentContext);
